import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack } from "@mui/material";
import { useCompany } from "../CompanyProvider/CompanyProvider";
import { maybeChangeHomeUrl } from "../ConditionalLink";
import { TypographyNavLink } from "../Typographies/TypographyNavLink";
import { AccountRoutesType, DefaultRoutesText } from "./navigationUtils";
export const LoggedOutNav = () => {
    const { url } = useCompany();
    const homeLocation = maybeChangeHomeUrl(url);
    return (_jsxs(Stack, Object.assign({ spacing: 3, direction: "row", flexWrap: "wrap", alignItems: "baseline" }, { children: [_jsx(TypographyNavLink, Object.assign({ className: "is-logged-out-nav", to: homeLocation }, { children: DefaultRoutesText.HOME })), _jsx(TypographyNavLink, Object.assign({ className: "is-logged-out-nav", to: AccountRoutesType.ORDERS }, { children: DefaultRoutesText.ACCOUNT }))] })));
};
